module.exports = __webpack_public_path__ + "static/media/8.55291bb8.jpg";